import React from 'react';
import { Row, Col, Button, ButtonGroup, Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faTrashAlt,
    faLock,
    faMapMarkerAlt,
    faListUl
} from '@fortawesome/free-solid-svg-icons';

// Constants & Common
import { APP_COLORS } from '../../common/Constants';
import LinkButton from '../../common/components/LinkButton';

// Sub-Components
import SearchFilterTypeAhead from './SearchFilterTypeAhead';
import ExploreAccuracyConfig from "./ExploreAccuracyConfig";
import AppliedFilters from "./filters/AppliedFilters"; // Adjust path if needed

const ExploreToolbar = (props) => {
    const {
        // --- Data Props ---
        loading,
        totalCompanies,
        totalContacts,
        hasFilter,
        canExport,
        currentUniverse,
        legacyModeString, // 'COMPANY' or 'CONTACT'
        accuracyData,
        toggleMap,
        exploreByContact,

        // --- Action Props ---
        handleClearAllFilter,
        handleSearch,
        onExport,           // Callback for opening Export Dialog
        onImport,           // Callback for opening Import Dialog
        onSaveSearch,       // Callback for opening Save Dialog
        onSearchSelected,   // Callback when a saved search is selected
        onAccuracyChange,   // Callback when accuracy slider changes
        onToggleMap         // Callback when switching Map/List
    } = props;

    return (
        <div className="panel" style={{ backgroundColor: APP_COLORS['gray-100'] }}>

            {/* --- Top Filter Bar (Applied Filters & Actions) --- */}
            <div className="filters-panel">
                <div style={{ padding: '7px 0 0 5px' }}>
                    <span className="md" style={{ color: APP_COLORS['tech-blue'] }}>Filters </span>
                    <LinkButton
                        size={'md'}
                        onClick={handleClearAllFilter}
                        style={{ paddingTop: 0 }}
                    >
                        <div>
                            <FontAwesomeIcon size="xs" color={APP_COLORS.info} icon={faTrashAlt} />
                            <span className="small" style={{ color: APP_COLORS.info, fontWeight: '400' }}> CLEAR ALL</span>
                        </div>
                    </LinkButton>
                </div>

                {/* Applied Filters Component */}
                <AppliedFilters />

                {/* Apply Button / Loading Indicator */}
                {loading ? (
                    <Button
                        className="btn-min-width-120 btn-height-35"
                        style={{ marginLeft: 'auto' }}
                        variant="info"
                        disabled
                    >
                        <Spinner
                            style={{ marginRight: '5px', verticalAlign: 'baseline' }}
                            as="span" animation="border" size="sm" role="status" aria-hidden="true"
                        />
                        Loading..
                    </Button>
                ) : (
                    <Button
                        className="btn-min-width-120 btn-height-35"
                        style={{ marginLeft: 'auto' }}
                        variant="info"
                        onClick={handleSearch}
                        data-cy="explore-search-apply-filter-button"
                    >
                        APPLY FILTER
                    </Button>
                )}
            </div>

            {/* --- Total Counts Display --- */}
            <Row style={{ marginTop: '10px' }}>
                <Col xl={12}>
                    <div>
                        <span className="small" style={{ color: APP_COLORS['tech-blue'] }}>
                            <span style={{ fontWeight: '600', color: APP_COLORS['orange'] }}>
                                {totalCompanies ? String(totalCompanies).replace(/(.)(?=(\d{3})+$)/g, '$1,') : 0}
                            </span> Companies |
                            <span style={{ fontWeight: '600', color: APP_COLORS['orange'], marginLeft: '5px'}}>
                                {totalContacts ? String(totalContacts).replace(/(.)(?=(\d{3})+$)/g, '$1,') : 0}
                            </span> Contacts
                        </span>
                    </div>
                </Col>
            </Row>

            <div className="horizontal-divider" />

            {/* --- Toolbar Actions (Export, Import, Save, Search, Config) --- */}
            <Row className="exploreToolBar">
                <Col xl={12} className="exploreTool">
                    <div className="exploreToolAction">
                        <Button
                            className="btn-min-width-120 btn-height-35"
                            variant="info"
                            onClick={onExport}
                            disabled={!canExport || !hasFilter}
                        >
                            EXPORT {!canExport && <>&nbsp;<FontAwesomeIcon icon={faLock} /></>}
                        </Button>
                        <Button
                            className="btn-min-width-120 btn-height-35"
                            variant="outline-secondary"
                            onClick={onImport}
                        >
                            IMPORT
                        </Button>
                        <Button
                            className="btn-min-width-120 btn-height-35"
                            variant="outline-secondary"
                            disabled={!hasFilter}
                            onClick={onSaveSearch}
                        >
                            SAVE
                        </Button>

                        <SearchFilterTypeAhead
                            style={{ marginLeft: '10px', width: '300px' }}
                            mode={legacyModeString}
                            onChange={onSearchSelected}
                        />

                        <ExploreAccuracyConfig
                            accuracyData={accuracyData}
                            onChange={onAccuracyChange}
                        />
                    </div>

                    {/* Map/List Switcher */}
                    {!exploreByContact && (
                        <div className="exploreToolSwitch">
                            <ButtonGroup>
                                <Button
                                    variant={toggleMap ? "info" : "light"}
                                    onClick={() => onToggleMap(true)}
                                    className="btn-toggle"
                                >
                                    <FontAwesomeIcon icon={faMapMarkerAlt} />
                                </Button>
                                <Button
                                    variant={!toggleMap ? "info" : "light"}
                                    onClick={() => onToggleMap(false)}
                                    className="btn-toggle"
                                >
                                    <FontAwesomeIcon icon={faListUl} />
                                </Button>
                            </ButtonGroup>
                        </div>
                    )}
                </Col>
            </Row>
        </div>
    );
};

export default ExploreToolbar;
